import { AddCircle } from '@mui/icons-material'
import { Button, IconButton, TextField } from '@mui/material'
import './addCategories.css'
import CloseIcon from '@mui/icons-material/Close';
import { toast} from 'react-toastify';
import { useState } from 'react';
import axios from 'axios';
import Topic from './Topic'
import { API_ENDPOINT, HEADER_TOKEN } from '../../../constants/constants';
import { activeArranger } from '../../../utils/util';
import TopicImgUpload from '../../img-upload/topicImgUpload';
const AddCategories = (props)=>{
    const {show, setShow, categories, setCategories} = props
    const [tp, setTp] = useState("")
    const [mt, setMt] = useState([])
    const [image, setImage] = useState("");
    
    const addTopic = () => {
        if (tp === "") {
            toast("Please Enter Topic", { position: 'bottom-center', autoClose: 1000 });
        } else {
            const formData = new FormData();
            formData.append("category", tp);
            if (image) {
                formData.append("image", image);
            }
    
            axios.post(API_ENDPOINT + 'sam/add-category', formData, {
                ...HEADER_TOKEN,
                headers: {
                    ...HEADER_TOKEN.headers,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                let d = res.data;
                if (d.success) {
                    toast(d.message);
                    let tps = [...categories];
                    tps.push({ category: tp, status: "Active" });
                    let ars = activeArranger(tps);
                    setCategories(ars);
                    setShow(false);
                    setTp("");
                    setImage("");
                } else {
                    toast(d.message, { position: 'bottom-center', autoClose: 900 });
                }
            });
        }
    }
    
    const onChange = (e)=>{
        let v = e.target.value
        if(v ===""){
            setMt([])
        }else{
            let nm = [...categories]
            let nnm = nm.filter(n=>n.category.includes(v))
            setMt(nnm)
        }
        setTp(v)
    }
    const onKeyEnter = (e)=>{
        if (e.key === "Enter") {
            addTopic()
        }
    }
    const onCategorySelect = (cat)=>{
        setTp(cat)
    }
    return(
      <div style={{maxWidth: '600px', margin: 'auto', position: 'relative'}}>
  <div className='add-topic-ind'>
    <TextField
      onKeyDown={onKeyEnter}
      value={tp}
      onChange={onChange}
      variant="outlined"
      label="Enter Category"
      size="small"
    />
    </div>
  <TopicImgUpload banner={image} setBanner={setImage} />
    <div className='add-topic-ind' style={{ display: 'flex', alignItems: 'center' }}>
    <Button
      onClick={addTopic}
      variant="contained"
      startIcon={<AddCircle />}
      sx={{ marginLeft: '6px', alignSelf: 'center' }}
    >
      Add
    </Button>
    </div>
</div>

    )
}
export default AddCategories